import { cn } from "@/modules/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-surface-skeleton animate-pulse rounded-4xl", className)}
      {...props}
    />
  )
}

export { Skeleton }
